import React from "react";

interface FrameAnimatorProps {
  playing?: boolean;
  no_task?: boolean; // Optional prop to handle no task state
  completed?: boolean; // Optional prop to handle no task state
}

const FrameAnimator: React.FC<FrameAnimatorProps> = ({
  playing = true,
  no_task = true,
  completed = false,
}) => {
  return (
    <div className="flex gap-1 items-end h-5">
      <div
        data-testid="frame-bar"
        className={`
          w-[0.3rem] 2xl:w-[0.375rem] bg-blue-600
          ${no_task && " h-[15%]"}
          ${playing && completed && "h-[60%]"}
          ${playing && !completed && "animate-bar-1"}
        `}
      />
      <div
        data-testid="frame-bar"
        className={`
          w-[0.3rem] 2xl:w-[0.375rem] bg-blue-600
          ${no_task && " h-[15%]"}
          ${playing && completed && "h-[70%]"}
          ${playing && !completed && "animate-bar-2"}
        `}
      />
      <div
        data-testid="frame-bar"
        className={`
          w-[0.3rem] 2xl:w-[0.375rem] bg-blue-600
          ${no_task && " h-[15%]"}
          ${playing && completed && "h-[80%]"}
          ${playing && !completed && "animate-bar-3"}
        `}
      />
    </div>
  );
};

export default FrameAnimator;
